// @ts-strict-ignore
import { MetaElementUsageIdentityVO } from '@shared/vo/meta-element.vo';
import { PropertyVO } from '@project/components/article/model/vo/property.vo';
import { Connection } from '@3d-scene/model3d/connection';
import { InsertArticleHelper } from '../../insert-article.helper';
import { UndoDetachBusbarArticlesOperation } from '@shared/undo/operation/undo-detach-busbar-articles-operation';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';

export class Busbar {
  public originalUsageId: string;
  public newUsageIds: string[] = [];
  public articleId: number;
  public articleVersion: number;
  public backwardAcceptingIds: MetaElementUsageIdentityVO[] = [];
  public featureProperties: PropertyVO[] = [];
  public additionalLengthStart: number;
  public additionalLengthEnd: number;
  public connectedUsageIds: MetaElementUsageIdentityVO[] = [];
  public insertArticleHelper: InsertArticleHelper;
  public endOverhangChildrenUsageIds: string[];

  public detachOperation: UndoDetachBusbarArticlesOperation;

  public getAcceptingConnections(connectionInfoService: ConnectionInfoService): Connection[] {
    const acceptingConnections: Connection[] = [];
    for (const backwardId of this.backwardAcceptingIds) {
      const acceptingConnection: Connection = connectionInfoService.findConnectionByIdentity(backwardId);
      if (acceptingConnection) {
        acceptingConnections.push(acceptingConnection);
      }
    }
    return acceptingConnections;
  }

  public get connectedArticleUsageIds(): string[] {
    const articleUsageIds: string[] = [];
    for (const connectedId of this.connectedUsageIds) {
      if (articleUsageIds.indexOf(connectedId.articleUsageId) < 0) {
        articleUsageIds.push(connectedId.articleUsageId);
      }
    }
    return articleUsageIds;
  }
}
